import { NgModule } from '@angular/core';

import { AvaliacaoService } from './avaliacao.service';
import { CadastradorService } from './cadastrador.service';
import { IdentificadorService } from './identificador.service';
import { QuestaoService } from './questao.service';

@NgModule({
    providers: [
        AvaliacaoService,
        QuestaoService,
        IdentificadorService,
        CadastradorService,
    ],
})
export class GestorAvaliacaoModule {}
